const DataTable = ({ columns, data, onEdit, onDelete, loading, error }) => {
  if (loading) return <div className="sp-card"><p>Cargando...</p></div>;
  if (error) return <div className="sp-card sp-card--danger"><p>{error}</p></div>;
  if (!data.length) return <div className="sp-card"><p>No hay registros.</p></div>;

  return (
    <div className="sp-card" style={{ padding: 0, overflowX: 'auto' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ borderBottom: '1px solid var(--sp-border)', background: 'var(--sp-primary-soft)' }}>
            {columns.map(col => (
              <th key={col.key} style={{ padding: '0.75rem 1rem', textAlign: 'left', fontWeight: 800, fontSize: '0.85rem', color: 'var(--sp-text)' }}>
                {col.label}
              </th>
            ))}
            <th style={{ padding: '0.75rem 1rem', width: 120 }}>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, idx) => (
            <tr key={row.id ?? idx} style={{ borderBottom: '1px solid var(--sp-border)' }}>
              {columns.map(col => (
                <td key={col.key} style={{ padding: '0.75rem 1rem', fontSize: '0.9rem' }}>
                  {row[col.key]?.toString() ?? '—'}
                </td>
              ))}
              <td style={{ padding: '0.5rem 1rem', display: 'flex', gap: '0.4rem' }}>
                <button
                  className="sp-btn sp-btn--light"
                  style={{ minHeight: 36, padding: '0.3rem 0.8rem', fontSize: '0.82rem' }}
                  onClick={() => onEdit(row)}
                >
                  Editar
                </button>
                <button
                  className="sp-btn sp-btn--danger"
                  style={{ minHeight: 36, padding: '0.3rem 0.8rem', fontSize: '0.82rem' }}
                  onClick={() => onDelete(row.id)}
                >
                  Eliminar
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable;